import MessageTemplateListView from '@/views/MessageTemplates/MessageTemplateListView/MessageTemplateListView.vue'
import CreateMessageTemplateView from '@/views/MessageTemplates/CreateMessageTemplateView/CreateMessageTemplateView.vue'
import MessageTemplateDetailView from '@/views/MessageTemplates/MessageTemplateDetailView/MessageTemplateDetailView.vue'

export default [
  {
    path: '/merchants/:merchantID/message-templates',
    component: MessageTemplateListView,
    name: 'MessageTemplateList'
  },
  {
    path: '/merchants/:merchantID/message-templates/:messageTemplateID',
    component: MessageTemplateDetailView,
    name: 'MessageTemplateDetail'
  },
  {
    path: '/merchants/:merchantID/message-templates/create',
    component: CreateMessageTemplateView,
    name: 'MessageTemplateCreate'
  }
]
